export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-cell2/index.js